import { CatHeading } from '@blocks-react/components/Heading';
import { CvaHeadingProps } from '../types';

export const CvaHeading = ({
  children
}: CvaHeadingProps) => {
  return (
    <CatHeading className='mb-2' variant='label'>
      {children}
    </CatHeading>
  );
};
